import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IImageSettings } from '@app/core/interfaces/images-settings';

@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./hero.component.scss']
})
export class HeroComponent {
    @Input() public title: string = '';
    @Input() public subtitle: string = '';
    @Input() public imageUrl: string = '';
    @Input() public imageSettings: IImageSettings = {};
}
